import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ice-game',
  templateUrl: './ice-game.component.html',
  styleUrls: ['./ice-game.component.scss']
})
export class IceGameComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
